import { configureStore as configureReduxStore } from '@reduxjs/toolkit';
import { rootReducer } from '../reducers';
export default function configureStore(initialState = {}) {
  return configureReduxStore({
    preloadedState: initialState,
    reducer: rootReducer,
    middleware: getDefaultMiddleware => getDefaultMiddleware({
      immutableCheck: {
        warnAfter: 100 // ms
      }
    }),
    devTools: {
      name: 'pricing-pages-ui'
    }
  });
}